import { Outlet } from "react-router-dom";
import { BookOpenText } from "@phosphor-icons/react";
import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";
import { CompanyProvider, useCompany } from "../context/CompanyContext";
import { NotificationsProvider } from "../context/NotificationsContext";
import CompanySwitcher from "./CompanySwitcher";
import GlobalSearch from "./GlobalSearch";
import NotificationsBell from "./NotificationsBell";

export default function AppShell() {
  return (
    <CompanyProvider>
      <NotificationsProvider>
        <div className="min-h-screen flex bg-[#F5F5F5]">
          <Sidebar />
          {/* Mobile header */}
          <div className="lg:hidden fixed top-0 left-0 right-0 bg-white border-b border-[#E5E5E5] z-30 px-3 py-3 flex items-center gap-2" style={{ paddingTop: "max(12px, env(safe-area-inset-top))" }}>
            <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center flex-shrink-0">
              <BookOpenText size={16} weight="duotone" className="text-white" />
            </div>
            <div className="flex-shrink min-w-0 max-w-[160px] sm:max-w-[220px]">
              <CompanySwitcher />
            </div>
            <div className="flex-1" />
            <NotificationsBell />
            <div className="flex-shrink-0">
              <GlobalSearchMobile />
            </div>
          </div>
          {/* Desktop top bar with search */}
          <div className="hidden lg:flex fixed top-0 right-0 left-72 bg-[#F5F5F5]/80 backdrop-blur z-20 px-8 py-4 items-center gap-2">
            <ActiveCompanyTitle />
            <div className="flex-1" />
            <NotificationsBell />
            <GlobalSearch />
          </div>
          <main className="flex-1 min-w-0 pt-[64px] pb-[68px] lg:pt-[72px] lg:pb-0" style={{ paddingBottom: "max(68px, calc(68px + env(safe-area-inset-bottom)))" }}>
            <Outlet />
          </main>
          <MobileNav />
        </div>
      </NotificationsProvider>
    </CompanyProvider>
  );
}

function GlobalSearchMobile() {
  return <GlobalSearch />;
}

// Centered "active company" title — must be absolutely positioned so it stays
// dead-center of the content area regardless of the flex spacers on either
// side. The flex-1 spacer between the title and the search bar handles the
// in-flow placement; the absolute positioning visually centers the label.
function ActiveCompanyTitle() {
  const { activeCompany } = useCompany();
  if (!activeCompany?.name) return null;
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 pointer-events-none select-none"
      data-testid="active-company-title"
    >
      <div className="text-sm sm:text-base font-semibold text-[#171717] tracking-tight truncate max-w-[40vw]">
        {activeCompany.name}
      </div>
    </div>
  );
}
